import axios from 'axios';

const getApiBaseUrl = () => {
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  if (isLocalhost && process.env.REACT_APP_API_URL) {
    return `${process.env.REACT_APP_API_URL}/api`;
  }
  return '/api';
};

const API_BASE_URL = getApiBaseUrl();

const ResumeStorageService = {
  saveResume: async (resumeData, token) => {
    try {
      console.log('Attempting to save with token:', !!token);
      if (!token) {
        throw new Error('No authentication token available');
      }

      const response = await axios.post(
        `${API_BASE_URL}/resume/save`, 
        { resumeData }, 
        { 
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        }
      );
      console.log('Save successful:', !!response.data);
      return response.data;
    } catch (error) {
      console.error('Error saving resume:', error);
      throw error;
    }
  },

  loadResume: async (token) => {
    try {
      console.log('Attempting to load with token:', !!token);
      if (!token) {
        throw new Error('No authentication token available');
      }

      const response = await axios.get(
        `${API_BASE_URL}/resume/load`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      console.log('Load successful:', !!response.data);
      return response.data;
    } catch (error) {
      console.error('Error loading resume:', error);
      throw error;
    }
  }
};

export default ResumeStorageService;
